import { render, staticRenderFns } from "./Cavs.vue?vue&type=template&id=41227ec8"
import script from "./Cavs.vue?vue&type=script&lang=js"
export * from "./Cavs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports